// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html.theme-transition,html.theme-transition *,html.theme-transition *::before,html.theme-transition *::after{transition:background-color 300ms ease,color 300ms ease,border-color 300ms ease,box-shadow 300ms ease !important}`, "",{"version":3,"sources":["webpack://./src/components/theme-toggle/ThemeToggle.scss"],"names":[],"mappings":"AAAA,6GAIC,gHAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
